export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";